import { h } from 'preact';

export function IconHeart({ width = 25, height = 20, fill = 'currentColor', onClick = undefined, ...rest }) {
  return (
    <svg
      id="heart"
      width={width}
      height={height}
      data-name="heart"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 512 512"
      class="icon-heart"
      onClick={onClick}
      {...rest}
    >
      <defs>
        <style>{`.cls-1, .cls-2 { stroke-width: 0; }`}</style>
      </defs>
      <path
        class="cls-2"
        fill="red"
        d="M57,293.6l172.6,161.1c7.2,6.7,16.6,10.4,26.5,10.4s19.3-3.7,26.5-10.4l172.6-161.1c29-27,45.5-64.9,45.5-104.6v-5.5c0-66.8-48.2-123.7-114-134.7-43.6-7.3-87.9,7-119,38.1l-11.5,11.5-11.5-11.5c-31.1-31.1-75.5-45.4-119-38.1C59.7,59.8,11.5,116.7,11.5,183.4v5.5c0,39.6,16.4,77.6,45.5,104.6h0Z"
      />
      <path
        class="cls-1"
        fill="red"
        d="M225.8,462.7l-2.5-2.3L48.1,297.7C17.4,269.2,0,229.2,0,187.3v-3.3C0,113.6,50,53.2,119.2,40c39.4-7.6,79.7,1.5,111.8,24.1,9,6.4,17.4,13.8,25,22.3,4.2-4.8,8.7-9.2,13.5-13.3,3.7-3.2,7.5-6.2,11.5-9h0c32.1-22.6,72.4-31.7,111.8-24.2,69.2,13.2,119.2,73.7,119.2,144.1v3.3c0,41.9-17.4,81.9-48.1,110.4l-175.2,162.7-2.5,2.3c-8.2,7.6-19,11.9-30.2,11.9s-22-4.2-30.2-11.9h0ZM239.1,139.5c-.4-.3-.7-.7-1-1.1l-17.8-20h-.1c-23.1-26-58-37.8-92-31.3-46.6,8.9-80.2,49.5-80.2,96.9v3.3c0,28.5,11.9,55.8,32.8,75.2l175.2,162.7,175.2-162.7c20.9-19.4,32.8-46.7,32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9-34-6.5-69,5.4-92,31.2h-.1c-.1.2,0,0-.1.2l-17.8,20c-.3.4-.7.7-1,1.1-4.5,4.5-10.6,7-16.9,7s-12.4-2.5-16.9-7h0Z"
      />
    </svg>
  );
}
